import { render, staticRenderFns } from "./BaseCalendar.vue?vue&type=template&id=631b8d3e&"
import script from "./BaseCalendar.vue?vue&type=script&lang=js&"
export * from "./BaseCalendar.vue?vue&type=script&lang=js&"
import style0 from "./BaseCalendar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports